/**
 * validates job name against special characters
 * @param {import('yup').StringSchema} schema
 */
export const createValidJobNameValidator = schema => schema
  .min(3)
  .matches(/^[a-zA-Z0-9()_+\-.'\s]+$/, 'Use only letters and numbers as well as underscore, dash, period and brackets.');
